import * as jwt from 'jsonwebtoken';
import { SessionViewModel, UserTokenInfo } from 'stageclip-common';

export const LOCAL_STORAGE_SESSION_KEY = 'StageClip-ClippingPlatform-Session';

export function storeSession(session: SessionViewModel) {
  localStorage.setItem(LOCAL_STORAGE_SESSION_KEY, JSON.stringify(session));
}

export function loadSession(): SessionViewModel {
  return (JSON.parse(localStorage.getItem(LOCAL_STORAGE_SESSION_KEY)) || {}) as SessionViewModel;
}

export function clearSession() {
  localStorage.removeItem(LOCAL_STORAGE_SESSION_KEY);
}

export function getSessionToken(): string {
  return loadSession().sessionToken;
}

export function getParsedSessionToken(): UserTokenInfo {
  return jwt.decode(getSessionToken()) as UserTokenInfo;
}
